import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { SNACKBAR_MSG } from '../../common/projects.constants';

@Component({
    selector: 'app-disclaimer-box',
    imports: [MarkdownModule, MatCheckboxModule, CommonModule, FormsModule],
    templateUrl: './disclaimer-box.component.html',
    styleUrl: './disclaimer-box.component.scss'
})
export class DisclaimerBoxComponent {
  message: string = '';
  projectId: string = '';
  isChecked: boolean = false;
  isAccepted: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DisclaimerBoxComponent>,
    public readonly notificationService: NotificationService,
    public sharedService: SharedService,
    public readonly router: Router
  ) {
    this.message = data?.message;
    this.projectId = data?.projectId;
    this.isAccepted = data?.accepted;
    this.isChecked = this.isAccepted;
  }

  /**
   * Closes the dialog when the close button is clicked and navigate to projects.
   */
  onCloseClick = () => this.dialogRef.close();

  /**
   * Closes the dialog when the close button is clicked and navigate to projects.
   */
  onCancelClick = () => {
    this.dialogRef.close();
    this.notificationService.showSnackbar(
      SNACKBAR_MSG.ACCEPT_TERMS_FAILURE,
      2000
    );
    this.router.navigate(['/projects']);
  };

  /**
   * Handles the confirmation action for accepting terms and conditions.
   * Initiates an API call to accept terms for the given project ID.
   * 
   */
  onConfirm = () => {
    this.sharedService.acceptTermsAndConditions(this.projectId).subscribe(
      (data) => {
        if (data.accepted) {
          this.isAccepted = true;
          this.notificationService.showSnackbar(
            SNACKBAR_MSG.ACCEPT_TERMS_SUCCESS,
            2000
          );
          this.dialogRef.close();
        }
      },
      (error) => {
        this.isAccepted = false;
        this.notificationService.showSnackbar(
          SNACKBAR_MSG.ACCEPT_TERMS_FAILURE,
          2000
        );
      }
    );
  };
}
